export const MANAGE_MEMBERS = 'members';
export const MANAGE_GENERAL_INFO = 'general-info';
